import gsap from 'gsap'
import barba from '@barba/core'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { Navigation } from './navigation'
import { initLenis, scrollToStart, parallax } from './lenis'
import { initAlpine } from './alpine'
import { initSwiper } from './swiper'
import { initAnimations } from './animation'
import { initBenefits } from './benefits'
import { splitText } from './splitText'
import { initParallax } from './parallax'
import { initButtons } from './button'
import { initCursor, initCursorEvents, resetCursor, setCursorTransitioning } from './cursor'
import { initInviewAnimations } from './inview'
import { initFormModal } from './modal'
import { initGoogleMaps } from './map'
import { initSprig } from './sprig'
import { initCookieBanner } from './cookieBanner'
import { setHeaderColour, closeHeaderDropdowns, autoplayVideos, refreshScripts } from './utilities'
import { initTeamLargeSlider } from './teamLargeSlider'
import { initFlatWorldMap } from './flatWorldMap'
import { initGlobe } from './globe'

gsap.registerPlugin(ScrollTrigger)

const initBarba = () => {
	window.initialLoad = true

	const nav = new Navigation()
	const transition = document.querySelector('.transition')

	const initComponents = (data) => {

		document.fonts.ready.then(() => {			
			splitText()
			initAnimations()
			initInviewAnimations()
		})

		initSwiper()
		initButtons()
		initBenefits()
		initParallax()
		initGoogleMaps()
		initFlatWorldMap()
		initGlobe()
		initCursorEvents()
		initSprig()
		autoplayVideos(data.next.container)
		setHeaderColour(data.next.container, data.next?.url?.path || window.location.pathname)
		parallax()
		initTeamLargeSlider()
	}

	let pendingHash = null

	barba.init({
		debug: true,
		timeout: 10000,
		schema: {
			prefix: 'data-load'
		},
		transitions: [
			{
				name: 'transition',
				once(data) {},
				leave(data) {
					const done = this.async()

					pendingHash = data.trigger?.hash || null

					gsap.fromTo(transition, {
						opacity: 0
					}, {
						opacity: 1,
						duration: 0.3,
						onComplete: done
					})
				},
				afterLeave() {
					scrollToStart()
					nav.closeNavigation()
					ScrollTrigger.getAll().forEach(t => t.kill())
				},
				after(data) {
					const done = this.async()
					// console.log('after')

					gsap.fromTo(transition, {
						opacity: 1
					}, {
						opacity: 0,
						duration: 0.4,
						onComplete: done
					})

					if (pendingHash) {
						setTimeout(() => {
							const target = document.querySelector(pendingHash);
							if (target) {
								target.scrollIntoView({ behavior: 'smooth' });
								history.replaceState(null, null, pendingHash);
							}
							pendingHash = null;
						}, 1000);
					} else {
						pendingHash = null;
					}

				}
			}
		]
	})

	barba.hooks.once((data) => {
		initLenis()
		initAlpine()
		initCursor()
		initFormModal()
		initCookieBanner()
		initComponents(data)

		window.onload = function () {
			window.initialLoad = false
			document.documentElement.classList.add('is-ready')
		}
	})

	barba.hooks.leave((data) => {
		closeHeaderDropdowns()
		setCursorTransitioning(true)
	})

	barba.hooks.enter((data) => {
		htmx.process(data.next.container)
	})

	barba.hooks.after((data) => {
		initComponents(data)
		initFormModal()
		refreshScripts(data.next.container)

		const focusableElement = data.next.container.querySelector('main')
		if (focusableElement) focusableElement.focus()

		setCursorTransitioning(false)
	})
}

export default initBarba